// import store from '../redux/store';

import store from '../../redux/store';

// In-memory text counter
let textCounter = 0;

function parseTextNumber(textName) {
  if (!textName) return 0;
  const match = textName.match(/^Text(?:\s+(\d+))?$/i);
  if (match && match[1]) return parseInt(match[1], 10);
  return 0;
}

// Initialize counter from scene
export function initializeTextCounterFromScene(scene) {
  textCounter = 0;
  if (!scene) return;

  scene.traverse((obj) => {
    if (obj.deleteType === 'text') {
      const textName = obj.file_name || obj.asset_file_name || obj.name;
      if (!textName) return;

      const number = parseTextNumber(textName);
      if (textCounter <= number) {
        textCounter = number + 1;
      }
    }
  });

  
}

// Initialize counter from Redux
export function initializeTextCounterFromRedux() {
  textCounter = 0;

  const state = store.getState();
  const sceneTexts = state.data?.sceneTexts || [];

  sceneTexts.forEach((textObj) => {
    if (textObj.deleteType === 'text') {
      const textName =
        textObj.file_name || textObj.asset_file_name || textObj.name;
      if (!textName) return;
      const number = parseTextNumber(textName);
      if (textCounter <= number) {
        textCounter = number + 1;
      }
    }
  });

  
}

// Get next text name and increment counter
export function getNextTextName(scene = null) {
  // Always reinitialize from scene to get latest state
  if (scene) {
    initializeTextCounterFromScene(scene);
  } else {
    initializeTextCounterFromRedux();
  }

  let textName;
  if (textCounter === 0) {
    textName = 'Text'; // First instance: "Text"
  } else {
    textName = `Text ${textCounter}`; // Subsequent: "Text 1", "Text 2"
  }

  textCounter++;
  

  return textName;
}

// Reset counter
export function resetTextCounter() {
  textCounter = 0;
  
}
